'use client';

import { useScroll, useTransform } from 'framer-motion';
import { useState } from 'react';

import { IconButton } from '@/decodo/components/atoms/IconButton';
import { Text } from '@/decodo/components/atoms/Text';

import AnimatedEl from '@/lib/motion';
import IconClose from '~/icons/x.svg';

export type PopupBannerProps = {
  image: React.ReactNode;
  title: string;
  description: React.ReactNode;
  cta?: React.ReactNode;
};

export const PopupBanner = ({
  image,
  title,
  description,
  cta,
}: PopupBannerProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const { scrollY } = useScroll();

  const opacity = useTransform(scrollY, [200, 480], [0, 1]);
  const y = useTransform(scrollY, [240, 440], ['100%', '0%']);

  return (
    <AnimatedEl
      el='div'
      // TODO: investigate what is wrong with these bloody values 😭
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      style={{ opacity, y, visibility: isVisible ? 'visible' : 'hidden' }}
      aria-hidden={!isVisible}
      className='bg-base-white shadow-popup fixed bottom-6 left-6 z-[100] hidden min-w-[320px] max-w-[600px] items-center gap-6 rounded p-6 md:flex'
    >
      <div className='flex flex-col gap-y-3'>
        <div className='flex gap-x-3'>
          {image}
          <Text variant='subtitle-l-d' classNames={{ wrapper: 'font-serif' }}>
            {title}
          </Text>
        </div>
        {description}
      </div>
      {cta}
      <IconButton
        variant='text'
        classNames={{
          root: 'absolute top-2 right-2 p-0 h-6 w-6',
          inner: 'text-gray-500 hover:text-base-black',
        }}
        size='s'
        color='secondary'
        slim
        onClick={() => setIsVisible(!isVisible)}
      >
        <IconClose />
      </IconButton>
    </AnimatedEl>
  );
};
